import { TaskRoleDetail, UserTaskRole, ProjectRolePermission } from 'common/types';

// 平台权限 + 项目角色权限列表
export const getRolePermission = (params: {
  roles?: UserTaskRole[];
  platformPermission?: string[];
  projectPermission?: ProjectRolePermission;
}) => {
  const { roles = [], platformPermission = [], projectPermission = [] } = params;
  return roles.reduce((pre, cur) => [...pre, ...(projectPermission[cur] || [])], platformPermission);
};

// 获取并解析角色权限
export const getParentTaskRoleInfo = (params: {
  roles?: UserTaskRole[];
  platformPermission?: string[];
  projectPermission?: ProjectRolePermission;
}): TaskRoleDetail => {
  const { roles = [] } = params;

  return {
    originRole: roles,
    isAdmin: roles.includes(UserTaskRole.Admin),
    isWatcher: roles.includes(UserTaskRole.Watcher),
    isAllocator: roles.includes(UserTaskRole.Allocator),
    isInternalContacts: roles.includes(UserTaskRole.InternalContacts),
    isExternalContacts: roles.includes(UserTaskRole.ExternalContacts),
    permission: getRolePermission(params),
  };
};
